(function ($) {
  Drupal.behaviors.lastGuideB5Media = {
    attach (context, settings) {
      updateImageAttributes();
      stepUpdateImages();
      $(window).on('resize', () => {
        updateImageAttributes();
        stepUpdateImages();
      });
    },
  };

  function updateImageAttributes () {
    const imgTag = $('.node--type-card .field--name-field-media-image picture img');
    setImageAttributes(imgTag);
  }

  function stepUpdateImages () {
    const imgWrapper = $('.node--type-card .step-gallery-container .gallery a');
    imgWrapper.each(function () {
      const imgTag = $(this).find('img');
      const width = Math.round(imgTag.width());
      if (width === 0) {
        imgTag.attr('width', 0);
        imgTag.attr('height', 0);
      } else {
        setImageAttributes(imgTag);
      }
    });
  }

  function setImageAttributes (imgTag) {
    const width = Math.round(imgTag.width());
    const height = Math.round(imgTag.height());
    imgTag.attr('width', width);
    imgTag.attr('height', height);
  }
}(jQuery));
